import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { withRouter } from "../utils/withRouter";
import ProductBox from "../components/productBox";
import ProductItemModel from "../models/product-item-model";
import CommonService from "../services/common.service";
import configData from "../config.json";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface ProductsPageState {
    count: number;
    selectedDate?: Date;
    productId: string;
    productsList?: Array<ProductItemModel>;
    allowedDates?: Array<Date>;
    translations: Record<string, any>;
}

interface ProductsPageProps {
    params: {
        id: string;
    };
}

class ProductsPage extends Component<ProductsPageProps, ProductsPageState> {
    constructor(props: ProductsPageProps) {
        super(props);
        const prodID = this.props.params.id;
        const translations = JSON.parse(localStorage.getItem('translations') || '[]');
        this.state = {
            count: 0,
            selectedDate: new Date(),
            productId: prodID ? prodID : '',
            productsList: [],
            translations: translations
        };
    }

    async componentDidMount() {
        userEventService.sendEvent('page_view', 'products_page_open', { productId: this.state.productId });
        await this.checkCartForEvents();
        await this.loadEvents();
    }

    async checkCartForEvents() {
        const cartData = localStorage.getItem('cart');
        if (cartData) {
            const cart = JSON.parse(cartData);
            if (cart && cart.events && cart.events.length > 0) {
                if (window.confirm(this.state.translations.filter((item: any) => item.setting_name === 'CART_CONFLICT')[0]?.setting_value_text)) {
                    window.location.href = '/cart';
                }
                else {
                    localStorage.removeItem('cart');
                    localStorage.removeItem('cartExpiryTime');
                    localStorage.removeItem('uuid');
                    window.location.href = '/';
                }
            }
        }
    }

    async loadEvents() {
        this.setState({ productsList: [] });
        common.getEvents(this.state.productId).then(products => {
            const today = this.state.selectedDate?.getFullYear() + '-' +
                          ('0' + (this.state.selectedDate?.getMonth()! + 1)).slice(-2) + '-' +
                          ('0' + this.state.selectedDate?.getDate()).slice(-2);
            let prodsList: any = [];
            let allowedDates: Array<Date> = [];
            products.forEach((element: any) => {
                element?.dates.forEach((dateItem: any) => {
                    dateItem.dates?.forEach((item: any) => {
                        allowedDates.push(item.date);
                        const images = element.images.map((kep: any) => configData.PATH + kep.image_content);
                        const prodItem = {
                            service: element.parent_service, 
                            event_id: element.parent_event, 
                            id: item.id, 
                            label: element.box_title,
                            description: element.box_subtitle,
                            date: item.date, 
                            time: item.time,
                            price_eur: 0,
                            price_huf: element.parent_price,
                            available: item.available,
                            max_num: item.max_num,
                            images: images,
                            box_details: element.box_details,
                            box_details_en: element.box_details_en
                        };
                        if (prodItem.date === today) {
                            prodsList.push(prodItem);
                        }
                    });
                });
            });
            this.setState({ productsList: prodsList });
            this.setState({ allowedDates: allowedDates });
        });
    }

    setDate(date: Date) {
        this.setState({selectedDate: date ? date : new Date()})
        this.loadEvents();
    }

    increment = () => {
        this.setState({ count: this.state.count + 1 });
    }

    render() {
        return (
            <Container className="oc-products">
                <Row className="oc-page-title">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h2>{this.state.translations.filter((item: any) => item.setting_name === 'UPCOMING_EVENTS')[0].setting_value_text}</h2>
                    </Col>
                </Row>
                <Row className="oc-page-content">
                    <Col lg={3} md={6} sm={12} xs={12}>
                        <h4>{this.state.translations.filter((item: any) => item.setting_name === 'CHOOSE_DATE')[0].setting_value_text}</h4>
                        <DatePicker 
                            inline 
                            includeDates={this.state.allowedDates} 
                            selected={this.state.selectedDate} 
                            onChange={(date) => this.setDate(date ? date : new Date())}>
                        </DatePicker>
                    </Col>
                    <Col lg={9} md={6} sm={12} xs={12}>
                        <h3>{this.state.selectedDate?.toDateString()}</h3>
                        { this.state.productsList?.map(product => (
                            <ProductBox service={this.state.productId} key={product.id} productData={product}></ProductBox>
                        ))}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(ProductsPage);